<template>
    <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="120px">
        <el-form-item label="版本号" prop="version" v-if="rule.id == 0">
            <el-input placeholder="请输入版本号" v-model="rule.version" clearable></el-input>
        </el-form-item>
        <el-form-item label="版本号" v-else>
            {{rule.version}}
        </el-form-item>
        <el-form-item label="选择app文件" prop="file" v-if="rule.id == 0">
            <el-upload
                class="upload-demo"
                ref="upload"
                :limit="1"
                action="#"
                :on-change="uploadChange"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :file-list="fileList"
                :auto-upload="false">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
            <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
        </el-form-item>
        <el-form-item label="app文件" v-else>
            {{rule.name}}
        </el-form-item>
        <el-form-item label="描述" prop="description">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入描述" v-model="rule.description" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button @click="block">返回</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        data() {
            let validateFileUrl = (rule, value, callback) => {
                if (value == '' || value == undefined) {
                    callback(new Error("请上传app文件"))
                } else {
                    callback()
                }
            }
            return {
                progressFlag:false,
                loadProgress:0,
                rule: {
                    id: 0,
                    file:'',
                    name:'',
                    description:'',
                    version:'',
                },
                rules: {
                    file: {required: true, validator: validateFileUrl,trigger: 'change' },
                    description: {required: true, message: '请输入描述'},
                    version: {required: true, message: '请输入版本号'},
                },
                fileList:[]
            }
        },
        async created() {
            if(this.$route.params.id) {
                if(this.$store.state.editInfo.length == 0) {
                    this.$router.push('/apk/index/index');
                }else {
                    this.rule = this.$store.state.editInfo;
                }
            }
        },
        methods:{
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        if(this.rule.id == 0) {
                            let headers = {
                                'Content-Type': 'multipart/form-data'
                            };
                            let formData = new FormData();
                            formData.append('file',this.rule.file);
                            formData.append('description',this.rule.description);
                            formData.append('version',this.rule.version);
                            formData.append('name',this.rule.name);
                            this.$http.post('/manage/app/upload',formData,{
                                    headers:headers,
                                    onUploadProgress:(ProgressEvent)=> {
                                        let status = (((ProgressEvent.loaded / ProgressEvent.total) * 100) | 0);
                                        this.progressFlag = true;
                                        this.loadProgress = status;
                                    }
                                }).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/apk/index/index');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }else {
                            this.$http.post('/manage/app/update',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/apk/index/index');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }
                    }
                });
            },
            block() {
                this.$router.push('/apk/index/index');
            },
            handleRemove() {
                this.rule.file = [];
                this.loadProgress = 0;
                this.progressFlag = false;
            },
            handlePreview() {
            },
            uploadChange(file) {
                this.rule.file = file.raw;
                this.rule.name = file.raw.name
                this.$refs['forms'].validateField('file');
            },
        }
    }
</script>